/** Trial display helpers for Current Subscription UI. */

export function getSubscriptionTrialInfo(subscription) {
  if (!subscription) {
    return { isTrial: false, daysRemaining: null, trialEndsAt: null, trialLengthDays: null };
  }
  const status = String(subscription.status || '').toLowerCase();
  const cycle = String(subscription.billing_cycle || '').toLowerCase();
  const trialEndsAt =
    subscription.trial_ends_at || (cycle === 'trial' ? subscription.current_period_end : null);
  const isTrial =
    Boolean(subscription.is_trial) ||
    status === 'in_trial' ||
    status === 'trialing' ||
    cycle === 'trial';

  let daysRemaining = subscription.trial_days_remaining;
  if (isTrial && (daysRemaining == null || Number.isNaN(Number(daysRemaining))) && trialEndsAt) {
    const ms = new Date(trialEndsAt).getTime() - Date.now();
    daysRemaining = ms <= 0 ? 0 : Math.ceil(ms / 86400000);
  }

  const trialLengthDays = subscription.plan?.trial_days || null;
  return {
    isTrial,
    daysRemaining: daysRemaining == null ? null : Number(daysRemaining),
    trialEndsAt,
    trialLengthDays,
  };
}

export function formatTrialDaysLeft(daysRemaining) {
  if (daysRemaining == null) return '';
  if (daysRemaining <= 0) return 'Trial ends today';
  if (daysRemaining === 1) return '1 day left in trial';
  return `${daysRemaining} days left in trial`;
}
